import React from "react";

type CalculatorProps = React.SVGProps<SVGSVGElement>;

export const Calculator = (props: CalculatorProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_6655_1389)">
      <path
        d="M0.833008 20H19.1663V2.5C19.1663 1.83696 18.903 1.20107 18.4341 0.732233C17.9653 0.263392 17.3294 0 16.6663 0L3.33301 0C2.66997 0 2.03408 0.263392 1.56524 0.732233C1.0964 1.20107 0.833008 1.83696 0.833008 2.5V20ZM2.49967 2.5C2.49967 2.27899 2.58747 2.06702 2.74375 1.91074C2.90003 1.75446 3.11199 1.66667 3.33301 1.66667H16.6663C16.8874 1.66667 17.0993 1.75446 17.2556 1.91074C17.4119 2.06702 17.4997 2.27899 17.4997 2.5V18.3333H2.49967V2.5ZM4.16634 8.33333H15.833V3.33333H4.16634V8.33333ZM5.83301 5H14.1663V6.66667H5.83301V5ZM4.16634 10.8333H5.83301V12.5H4.16634V10.8333ZM7.49967 10.8333H9.16634V12.5H7.49967V10.8333ZM12.4997 10.8333V12.5H10.833V10.8333H12.4997ZM4.16634 14.1667H5.83301V15.8333H4.16634V14.1667ZM7.49967 14.1667H9.16634V15.8333H7.49967V14.1667ZM14.1663 10.8333H15.833V12.5H14.1663V10.8333ZM10.833 14.1667H15.833V15.8333H10.833V14.1667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6655_1389">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
